<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EhRGXM/tc-custom/9781644054604.jpg?1718183001577" alt="This image is the cover for the book Sauveteur, Série 415 Ink"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sauveteur, Série 415 Ink
      </h1>
      <p class="bookDescription body article font2">
        <p>Dans tout homme bon, il y a un sauveteur, mais parfois, c’est l’amour qui réveille l’homme dans le sauveteur. </p><p>Mace Crawford, sapeur-pompier de San Francisco, a connu une enfance difficile. Enlevé par nécessité à son épouvantable père, il a été élevé dans le système fédéral, froid et indifférent. Devenu adulte, il consacre sa vie à sauver les autres, y compris les frères qu’il s’est choisis. Second de sa brigade, Mace guide ceux qui sont sous ses ordres ; à 415 Ink, le salon de tatouage familial, il apporte son aide, mais par-dessus tout, il protège sa famille de son secret le plus sombre. </p><p>Alors qu’il s’est juré de ne jamais aimer, un gros problème apparaît dans sa vie solitaire : Rob Claussen, un des tatoueurs de 415 Ink, l’obsède de plus en plus.</p><p>Mace a édifié de strictes frontières pour protéger son univers contrôlé – et son cœur, mieux barricadé encore. Il ne peut y faire entrer Rob, il ne peut céder à son désir sans risquer d’abattre les fondations mêmes de l’existence qu’il s’est bâtie. </p><p>Un jour pourtant, un démon du passé refait surface et Mace est alors confronté à un choix : s’accrocher à ses mensonges ou sauver celui qu’il a si peur d’aimer. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rhys Ford, Anne Solo
      </h2>
      
      <p class="authorDescription body article">&#160;Rhys Ford is an award-winning author with several long-running LGBT+ mystery, thriller, paranormal, and urban fantasy series and is a two-time LAMBDA finalist with her Murder and Mayhem novels. She is also a 2017 Gold and Silver Medal winner in the Florida Authors and Publishers President&rsquo;s Book Awards for her novels <I>Ink and Shadows</I> and <I>Hanging the Stars</I>. She is published by Dreamspinner Press and DSP Publications.<BR />She shares the house with Harley, a gray tuxedo with a flower on her face, Badger, a disgruntled alley cat who isn&rsquo;t sure living inside is a step up the social ladder, as well as a ginger cairn terrorist named Gus. Rhys is also enslaved to the upkeep of a 1979 Pontiac Firebird and enjoys murdering make-believe people.<BR />Rhys can be found at the following locations:<BR />Blog: www.rhysford.com<BR />Facebook: www.facebook.com/rhys.ford.author<BR />Twitter: @Rhys_Ford<BR />&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a20f490